<template>
    <v-card outlined>
        <v-card outlined class="elevation-0">
            <!--grid-->
            <v-card-actions class="trades-pair">
                <div class="flex-grow-1 pa-1 font-weight-medium" style="border: 1px solid rgba(255, 255, 255, 0.5)"
                    v-for="trade in trades" :key="trade.pair">
                    <div class="d-flex justify-space-between flex-grow-1 cols-1">
                        <div class="font-weight-bold">{{ trade.pair }}</div>
                        <div class="d-flex items-center">
                            {{ $t('plexus.tileView.counterpartyLabel') }} <v-btn icon small><v-icon small>mdi-menu</v-icon></v-btn>
                        </div>
                    </div>
                    <div class="d-flex justify-center flex-column items-center mx-auto flex-grow-1 text-center">
                        <div>64M</div>
                        <div>{{ trade.side }} {{ trade.pair.slice(0, 3) }}</div>
                        <div class="amount-size">
                            {{ trade.price.slice(0, 4) }}
                            <span class="trade-price" :class="formatColor(trade)">{{
                                trade.price.slice(4, 6)
                                }}</span>
                            {{ trade.price.slice(-1) }}
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-space-between">
                        <div class="d-flex flex-gap-2">
                            <div class="border-trades">{{ $t('plexus.tileView.swapLabel') }}</div>
                            <div>{{ $t('plexus.tileView.spotLabel') }}</div>
                        </div>
                        <div>{{ trade.date }}</div>
                    </div>
                    <div class="d-flex flex-row justify-space-between">
                        <div class="d-flex">
                            <div class="border-trades" :class="formatColorInverse(trade)">
                                {{ trade.side }}
                            </div>
                            <div class="primary--text border-trades">
                                {{ trade.pair.slice(0, 3) }}
                            </div>
                        </div>
                        <div class="d-flex">
                            {{ trade.amount }}
                            <div class="d-flex flex-column ml-1">
                                <v-icon x-small>mdi-arrow-up</v-icon>
                                <v-icon x-small>mdi-arrow-down</v-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-actions>
        </v-card>
        <v-card outlined class="elevation-0 pa-0">
            <v-tabs background-color="black" height="25">
                <v-tab v-for="(item, index) in mainTabs" class="font-weight-light" :key="index">
                    {{ item }}
                </v-tab>
            </v-tabs>
            <v-card class="d-flex flex-column pa-0" outlined>
                <v-tabs background-color="black" class="font-weight-light flex-grow-1" height="25">
                    <v-tab v-for="(item, index) in viewTabs" class="font-weight-light" :key="index">
                        {{ item }}
                    </v-tab>
                </v-tabs>

                <base-data-table dense :headers="headers" hide-default-footer :items="tradeTableItems" />
            </v-card>
        </v-card>
    </v-card>

</template>
<script>
export default {
    props: ['viewTabs', 'mainTabs', 'trades', 'headers', 'tradeTableItems'],
    methods: {
        formatColor(trade) {
            return trade.side.toUpperCase() === "SELL" ? "sell" : "buy";
        },
        formatColorInverse(trade) {
            return trade.side.toUpperCase() === "BUY" ? "sell" : "buy";
        },
    }
}
</script>
<style scoped>
.trades-pair {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background-color: #15171c;
  gap: 0.2rem;
  padding: 0.1rem;
}

@media screen and (max-width: 959px) {
  .trades-pair { grid-template-columns: repeat(2, 1fr); }
}
@media screen and (max-width: 599px) {
  .trades-pair { grid-template-columns: 1fr; }
}
</style>